import(/* webpackMode: "eager" */ "/vercel/path0/src/page/faq/Faq.jsx")